"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstraintsVB = void 0;
const pex_models_1 = require("@sphereon/pex-models");
const fieldsVB_1 = require("./fieldsVB");
const validationBundler_1 = require("./validationBundler");
class ConstraintsVB extends validationBundler_1.ValidationBundler {
    constructor(parentTag) {
        super(parentTag, 'constraints');
        this.disclosureLimitShouldHaveKnownValueMsg = 'limit_disclosure should have known value';
        this.statusShouldHaveKnownValueMsg = 'Unknown status property';
        this.statusDirectiveShouldHaveKnownValueMsg = 'status directive should have known value';
        this.subjectIsIssuerShouldBeKnownValueMsg = 'subject_is_issuer should be known value';
        this.fieldIdIsMandatoryMsg = 'field_id property is mandatory';
        this.fieldIdMustBeArrayOfStringsMsg = 'field_id property must be an array of strings';
        this.fieldIdMustCorrespondToFieldIdMsg = 'field_id must correspond to a present field object id property';
        this.directivePropertyIsMandatoryMsg = 'directive property is mandatory';
        this.oneOfTheKnownDirectivePropertiesMandatoryMsg = 'directive property must be one of [required, preferred]';
    }
    getValidations(constraints) {
        let validations = [];
        if (constraints) {
            validations = [
                {
                    tag: this.getTag(),
                    target: constraints,
                    predicate: (constraints) => ConstraintsVB.disclosureLimitShouldHaveKnownValue(constraints.limit_disclosure),
                    message: this.disclosureLimitShouldHaveKnownValueMsg,
                },
                {
                    tag: this.getTag(),
                    target: constraints,
                    predicate: (constraints) => ConstraintsVB.statusShouldHaveKnownValue(constraints.statuses),
                    message: this.statusShouldHaveKnownValueMsg,
                },
                {
                    tag: this.getTag(),
                    target: constraints,
                    predicate: ConstraintsVB.statusDirectiveShouldHaveKnownValue(),
                    message: this.statusDirectiveShouldHaveKnownValueMsg,
                },
                {
                    tag: this.getTag(),
                    target: constraints,
                    predicate: (constraints) => ConstraintsVB.shouldBeKnownOption(constraints.is_holder),
                    message: this.subjectIsIssuerShouldBeKnownValueMsg,
                },
                {
                    tag: this.getTag(),
                    target: constraints,
                    predicate: (constraints) => this.fieldIdInSubjectMustCorrespondToFieldId(constraints, constraints.is_holder),
                    message: this.fieldIdMustCorrespondToFieldIdMsg,
                },
                {
                    tag: this.getTag(),
                    target: constraints,
                    predicate: (constraints) => this.fieldIdInSubjectMustCorrespondToFieldId(constraints, constraints.same_subject),
                    message: this.fieldIdMustCorrespondToFieldIdMsg,
                },
                ...this.getSubjectsValidations(constraints === null || constraints === void 0 ? void 0 : constraints.is_holder),
                ...this.getSubjectsValidations(constraints === null || constraints === void 0 ? void 0 : constraints.same_subject),
                ...this.getFieldsValidations(constraints),
            ];
        }
        return validations;
    }
    getFieldsValidations(constraints) {
        var _a;
        if ((_a = constraints === null || constraints === void 0 ? void 0 : constraints.fields) === null || _a === void 0 ? void 0 : _a.length) {
            return new fieldsVB_1.FieldsVB(this.getTag()).getValidations(constraints.fields);
        }
        return [];
    }
    static disclosureLimitShouldHaveKnownValue(limit_disclosure) {
        return !limit_disclosure || limit_disclosure === pex_models_1.Optionality.Preferred || limit_disclosure === pex_models_1.Optionality.Required;
    }
    static statusShouldHaveKnownValue(statuses) {
        return statuses == null || statuses.active != null || statuses.revoked != null || statuses.suspended != null;
    }
    static statusDirectiveShouldHaveKnownValue() {
        return (constraints) => {
            var _a, _b, _c;
            return this.pdStatusShouldBeKnown((_a = constraints === null || constraints === void 0 ? void 0 : constraints.statuses) === null || _a === void 0 ? void 0 : _a.active) &&
                this.pdStatusShouldBeKnown((_b = constraints === null || constraints === void 0 ? void 0 : constraints.statuses) === null || _b === void 0 ? void 0 : _b.revoked) &&
                this.pdStatusShouldBeKnown((_c = constraints === null || constraints === void 0 ? void 0 : constraints.statuses) === null || _c === void 0 ? void 0 : _c.suspended);
        };
    }
    static pdStatusShouldBeKnown(pdStatus) {
        return (!pdStatus ||
            pdStatus.directive === pex_models_1.Directives.Allowed ||
            pdStatus.directive === pex_models_1.Directives.Disallowed ||
            pdStatus.directive === pex_models_1.Directives.Required);
    }
    static shouldBeKnownOption(subjects) {
        if (subjects) {
            return (subjects.filter((subject) => subject.directive !== pex_models_1.Optionality.Preferred && subject.directive !== pex_models_1.Optionality.Required).length === 0);
        }
        return true;
    }
    getSubjectsValidations(holderSubjects) {
        if (holderSubjects) {
            let validations = [];
            for (let subjectInd = 0; subjectInd < holderSubjects.length; subjectInd++) {
                validations = [
                    {
                        tag: this.getMyTag(subjectInd),
                        target: holderSubjects[subjectInd],
                        predicate: (subject) => Array.isArray(subject.field_id),
                        message: this.fieldIdMustBeArrayOfStringsMsg,
                    },
                    {
                        tag: this.getMyTag(subjectInd),
                        target: holderSubjects[subjectInd],
                        predicate: (subject) => !!subject.field_id,
                        message: this.fieldIdIsMandatoryMsg,
                    },
                    {
                        tag: this.getMyTag(subjectInd),
                        target: holderSubjects[subjectInd],
                        predicate: (subject) => subject.field_id.length === subject.field_id.filter((id) => typeof id === 'string').length,
                        message: this.fieldIdMustBeArrayOfStringsMsg,
                    },
                    {
                        tag: this.getMyTag(subjectInd),
                        target: holderSubjects[subjectInd],
                        predicate: (subject) => subject.directive !== undefined,
                        message: this.directivePropertyIsMandatoryMsg,
                    },
                    {
                        tag: this.getMyTag(subjectInd),
                        target: holderSubjects[subjectInd],
                        predicate: (subject) => subject.directive === pex_models_1.Optionality.Preferred || subject.directive === pex_models_1.Optionality.Required,
                        message: this.oneOfTheKnownDirectivePropertiesMandatoryMsg,
                    },
                ];
            }
            return validations;
        }
        return [];
    }
    getMyTag(srInd) {
        // TODO extract to make it generic
        return this.parentTag + '.' + this.myTag + '[' + srInd + ']';
    }
    fieldIdInSubjectMustCorrespondToFieldId(constraints, subjects) {
        if (subjects) {
            for (const subject of subjects) {
                for (const fieldId of subject.field_id) {
                    if (!ConstraintsVB.isValidFieldId(constraints, fieldId)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    static isValidFieldId(constraints, fieldId) {
        if (constraints === null || constraints === void 0 ? void 0 : constraints.fields) {
            return constraints.fields.map((field) => field.id).includes(fieldId);
        }
        return false;
    }
}
exports.ConstraintsVB = ConstraintsVB;
